import * as React from "react";
import type { SVGProps } from "react";
const SvgMessageChat011 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19.467 9.867v-4.8a2.133 2.133 0 0 0-2.134-2.134h-12.8A2.133 2.133 0 0 0 2.4 5.067v8.348c0 1.178.955 2.133 2.133 2.133h1.67V20l4.452-4.452h.278m5.508 2.736 2.782 2.783v-2.783h.244a2.133 2.133 0 0 0 2.133-2.133v-3.618a2.133 2.133 0 0 0-2.133-2.133h-6.4a2.133 2.133 0 0 0-2.134 2.133v3.618c0 1.178.956 2.133 2.134 2.133z"
    />
  </svg>
);
export default SvgMessageChat011;
